import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { searchDoctors,searchDoctorsCategory } from "../Doctors/Services/searchDoctors";
import { useQuery } from '@tanstack/react-query';
import FetchDoctors from "./Services/FetchDoctors";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
// import { SwiperSlide } from "swiper/react";
//import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import { Navigation } from 'swiper/modules';
import "swiper/css/grid";
//import { Link } from 'react-router-dom';
// import DoctorsService from "../Doctors/Services/DoctorsService";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Swal from "sweetalert2";
import FetchCategory from "./Services/FetchCategory";

export default function MainPage() {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery-3.7.1.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/js/bootstrap-datetimepicker.min.js',
      'assets/js/slick.js',
      'assets/js/backToTop.js',
      'assets/js/aos.js',
      'assets/js/script.js'
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => {
            console.log(`Loaded: ${url}`);
            resolve();
          };
          script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }

      // Now init plugins after scripts are loaded
      if (!isCancelled) {
        // if (window.AOS) {
        //   window.AOS.init();
        // }

        if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
          window.$('.datetimepicker').datetimepicker();
        }

        // if (window.$ && typeof window.$.fn.slick === 'function') {
        //   window.$('.your-slick-class').slick(); // Replace with your actual class
        // }

        if (typeof window.initBackToTop === 'function') {
          window.initBackToTop(); // assuming your backToTop script defines this
        }

        console.log('All scripts loaded and initialized.');
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);
  //const [location, setLocation] = useState("");
  const [keyword, setKeyword] = useState("");
  const { data: doctorsReports = [] } = useQuery({
    queryKey: ['patientUserData'],
    queryFn: async () => {
      const response = await FetchDoctors.fetchDoctors();
      return response?.data?.data?.[0] ?? [];
    },
  });

  const navigate = useNavigate();
  const [searchLoading,setSearchLoading] = useState(false);
  const [searchLoading2,setSearchLoading2] = useState(false);
  const [loadingSpeciality, setLoadingSpeciality] = useState(null);
  const handleSearch = async (e) => {
    e.preventDefault();
    setSearchLoading(true);
    setSearchLoading2(true);
    const combinedKeyword = `${keyword}`.trim();

    try {
      //localStorage.clear();
      const response = await searchDoctors(combinedKeyword);
      console.log("Search results:", response.data);
      navigate("/search-doctors", { state: { results: response.data.data.flat() } });
      // you can store response.data into state and render it
    } catch (error) {
      console.error("Search error:", error);
    }
    finally{
      setSearchLoading(false);
      setSearchLoading2(false);
      setLoadingSpeciality(null);
    }
  };

   const handleCategorySearch = async (e,keyword) => {
    e.preventDefault();
    setSearchLoading(true);
    setSearchLoading2(true);
    const combinedKeyword = `${keyword}`.trim();

    try {
      //localStorage.clear();
      const response = await searchDoctorsCategory(combinedKeyword);
      console.log("Search results:", response.data);
      navigate("/search-doctors", { state: { results: response.data.data.flat() } });
      // you can store response.data into state and render it
    } catch (error) {
      console.error("Search error:", error);
    }
    finally{
      setSearchLoading(false);
      setSearchLoading2(false);
      setLoadingSpeciality(null);
    }
  };
  const today = new Date();
  const [doctorCategories,setDoctorCategories] = useState([]);
  useEffect(()=>{
    const fetch = async()=>{
      try {
        const response = await FetchCategory.fetchCategory();
        const data = response.data?.data?.flat() || [];
        setDoctorCategories(data);
      }catch(error){
        console.log(error);
      }
    }
    fetch();
  },[])
  const handleViewDoctor = async (doctorId) => {
    navigate(`/doctor-profile?query=${doctorId}`);
  }

  const formattedDate = today.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 600,
    cssEase: "ease",
    arrows: false,
    pauseOnHover: true,
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };
  const specialitySettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000, // 👈 give some delay
    speed: 600,
    cssEase: "ease",
    arrows: false,
    pauseOnHover: true,
    swipe: false,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  };
  const Slidersettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 800,
    arrows: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ]
  };
  return (
    <>
      <style>{`
  //     @media (min-width: 501px){
  //     .docs-image{
  //      width:100%;
  //      max-height:250px;
  //  }
  // }
  // // @media (max-width: 500px){
  // //    .docs-image{
  // //    width:100%;
  // //       max-height:250px;
  // //    }
  // }
    .features-slider-react {
  overflow: hidden;
}

.features-slider-react .slick-track {
  display: flex !important;
  align-items: center;
}

/* spacing between slider items */
.features-slider-react .slick-slide {
  padding: 10px;
}

.features-slider-react .slick-list {
  margin: 0 -10px; /* fix side gap */
}

/* feature item styling */
.feature-item {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
}

/* image styling */
.feature-item img {
  width: 100%;
  border-radius: 15px;
  display: block;
  border: 1px solid #54dcf1;
  padding: 5px;
  height: 180px;
  object-fit: cover;
}

/* TEXT AS BACKGROUND OVER IMAGE */
.feature-item p {
  position: absolute;
  bottom: 5px;
  left: 10px;
  right: 10px;
  margin: 0;
  padding: 2px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.6); /* dark overlay */
  border-radius: 8px;
}

/* hover effect */
.feature-item:hover img {
  transform: scale(1.05);
  transition: 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  transition: 0.3s ease;
}
  
@media (max-width: 480px) {
  .features-slider-react .slick-slide {
    padding: 5px;
  }

  .feature-item p {
    font-size: 11px;
    bottom: 6px;
    padding: 4px;
  }
}
/* spacing between items */
.specialities-slider-react .slick-slide {
  padding: 15px;
}
.specialities-slider-react .slick-list {
  margin: 0 -15px;
}

/* main card */
.speicality-item {
  background: #fff;
  border-radius: 20px;
  padding: 15px 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
}

/* image container */
.speicality-img {
  width: 80px;
  height: 80px;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fb;
  border-radius: 50%;
  transition: 0.3s;
}

/* image */
.speicality-img img {
  max-width: 45px;
}

/* text */
.speicality-item p {
  font-weight: 600;
  font-size: 15px;
  color: #333;
  margin: 0;
}

/* hover effect */
.speicality-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

/* hover icon background */
.speicality-item:hover .speicality-img {
  background: #0de0fe;
}

/* hover icon color (if SVG/png transparent) */
.speicality-item:hover img {
  filter: brightness(0) invert(1);

}
/* Hover Effect */
.feature-item:hover img {
  transform: scale(1.08);
}
.slick-slide {
  padding: 0 5px;
}
.slick-list {
  margin: 0 -5px;
}
  /* arrows container */
.slick-prev,
.slick-next {
  width: 20px;
  height: 20px;
  z-index: 10;
}

/* arrow background */
.slick-prev:before,
.slick-next:before {
  font-size: 20px;
  color: #0de0fe;
}

/* position */
.slick-prev {
  left: -25px;
}

.slick-next {
  right: -25px;
}
  @media (max-width: 1024px) {
  .slick-prev,
  .slick-next {
    width: 15px;
    height: 15px;
    // border:1px solid red;
    position: absolute;
    top: 25%;
    transform: translateY(-50%);
    z-index: 10;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 17px;
  }

  .slick-prev {
    left: -1px;
  }

  .slick-next {
    right: -1px;
  }
}
  `}</style>

      <div autoFocus>
        {/* Home Banner */}
        <section className="section section-search">
          <div className="container-fluid">
            <div className="banner-wrapper">
              <div className="banner-header text-center aos" data-aos="fade-up">
                <h1>Browse Doctors & Schedule Your Visit</h1>
                <p>Find doctors and healthcare services near you with ease.</p>
              </div>
              {/* Search */}
              <div className="search-box">
                <form onSubmit={handleSearch}>
                  <div className="mb-2 search-info aos" data-aos="fade-up" style={{ width: "100%" }}>
                    <input type="text" className="form-control rounded-pill py-2" placeholder="Search Doctors , Clinics , Hospitals , Specialities Etc"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)} style={{ border: '2px solid #605ad2' }} />
                    <span className="form-text mt-2" style={{ color: '#0C0C0C', textAlign: 'center' }}>Ex : Dental or Sugar Check up etc</span>
                  </div>
                  <button type="submit" className="btn btn-primary search-btn mt-0 aos" data-aos="fade-up" disabled={searchLoading}><i className="fas fa-search" /> <span>{searchLoading?"Searching ... ":"Search"}</span></button>
                </form>
              </div>
              {/* /Search */}
            </div>
          </div>
        </section>
        {/* /Home Banner */}
        <section className="section home-tile-section">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-9 m-auto">
                <div className="section-header text-center aos" data-aos="fade-up">
                  <h2>What are you looking for?</h2>
                </div>
                <div className="row">
                  <div className="col-lg-4 mb-2 aos" data-aos="fade-up">
                    <div className="card text-center doctor-book-card">
                      <img src="assets/img/visitdoctors.png" alt="doctor-image" className="img-fluid" />
                      <div className="doctor-book-card-content tile-card-content-1">
                        <div>
                          <h3 className="card-title mb-0">Visit a Doctor</h3>
                          <a href="/" role="button" onClick={(e) => { e.preventDefault(); handleSearch(e); }} className="btn book-btn1 px-2 py-1 mt-1" tabIndex={0}  disabled={searchLoading2}>
                          {(searchLoading2)?"Loading ...":"Book Now" }</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-2 aos" data-aos="fade-up">
                    <div className="card text-center doctor-book-card">
                      <img src="assets/img/img-pharmacy1.png" alt="pharmacy" className="img-fluid" />
                      <div className="doctor-book-card-content tile-card-content-1">
                        <div>
                          <h3 className="card-title mb-0"> Pharmacy Solutions</h3>
                          {/* <a href="/" role="button" onClick={(e) => { e.preventDefault(); }} className="btn book-btn1 px-2 py-1 mt-1" tabIndex={0}>Read More</a> */}
                          <a href="https://webnetcare.org/Clinicsolution"
                            className="btn book-btn1 px-2 py-1 mt-1" > Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-2 aos" data-aos="fade-up">
                    <div className="card text-center doctor-book-card">
                      <img src="assets/img/lab-image.png" alt="lab-image" className="img-fluid" />
                      <div className="doctor-book-card-content tile-card-content-1">
                        <div>
                          <h3 className="card-title mb-0">Lab Solutions</h3>
                          {/* <a href="/" role="button" onClick={(e) => { e.preventDefault(); }} className="btn book-btn1 px-2 py-1 mt-1" tabIndex={0}>Read More</a> */}
                          <a href="https://webnetcare.org/Clinicsolution"
                            className="btn book-btn1 px-2 py-1 mt-1"  >  Read More </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

       {/* Clinic and Specialities */}
<section className="section section-specialities">
  <div className="container-fluid">
    <div className="section-header text-center aos" data-aos="fade-up">
      <h2>Clinic And Specialities</h2>
      <p className="sub-title">Our clinic offers diverse medical specialities, expert doctors, and personalized care to ensure comprehensive health solutions for every patient’s needs.</p>
    </div>
    <div className="row justify-content-center">
      <div className="col-md-9 aos" data-aos="fade-up">
        <Slider {...specialitySettings} className="specialities-slider-react">
          {doctorCategories.map((spec) => (
            <div 
              key={spec.doctorsCategoryListId}
              className="speicality-item text-center" 
              onClick={(e) => { 
                e.preventDefault(); 
                setLoadingSpeciality(spec.doctorsCategoryListId); 
                handleCategorySearch(e,spec.doctorsCategoryName); 
              }} 
              style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                cursor: loadingSpeciality ? 'not-allowed' : 'pointer',
                opacity: loadingSpeciality ? 0.6 : 1 
              }}
            >
              <div className="speicality-img">
                <img src={`${serverConfig.BASE_URL}/uploads/${spec.logoCategory}`} 
                className="img-fluid" alt={spec.doctorsCategoryName} 
                onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "assets/img/doctor.png";
                              }}
                />
              </div>
              <p style={{ textAlign: 'center', marginTop: '10px' }}>
                {spec.doctorsCategoryName}
              </p>
              {loadingSpeciality === spec.doctorsCategoryListId && (
                <small style={{ color: '#0de0fe', marginTop: '5px', fontWeight: '500' }}>
                  Loading...
                </small>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>
</section>

        {/* Clinic and Specialities */}
        {/* Popular Section */}
        <section className="section section-doctor">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 aos" data-aos="fade-up">
                <div className="section-header ">
                  <h2>Book Our Doctor</h2>
                  <p>Schedule Your Doctor’s Appointment Today</p>
                </div>
                <div className="about-content">
                  <p>Book our doctor effortlessly and experience seamless healthcare services. Our platform allows you to schedule appointments with top specialists in just a few clicks. Whether you need a general check-up, a specialist consultation, or
                    follow-up care, our system ensures quick access to trusted medical professionals.</p>
                  <p>With real-time availability, user-friendly booking, and instant confirmations, managing your
                    health has never been easier. Take control of your well-being and book now.</p>
                  <a href="/" role="button" onClick={(e) => { e.preventDefault(); }}>Read More..</a>
                </div>
              </div>
              <div className="col-lg-8 aos" data-aos="fade-up">
                <Slider {...Slidersettings}>

                  {doctorsReports.length > 0 ? (
                    doctorsReports.map((doc) => (
                      <div className="profile-widget" key={`doctor-${doc.userId}`}>
                        <div className="doc-img">
                          <a href="/" 
                            role="button"
                             onClick={(e) => {
                                e.preventDefault();
                                doc?.showIdentity === 'Y' && doc?.kycAccept === 'Y'
                                  ? handleViewDoctor(doc?.userId)
                                  : Swal.fire({
                                    title: 'Warning!',
                                    text: 'Identity is not verified.',
                                    icon: 'warning',
                                    confirmButtonColor: '#566fe2',
                                    customClass: {
                                      title: 'swal-title-small',
                                      popup: 'swal-popup-small',
                                      confirmButton: 'swal-button-small'
                                    }
                                  });
                              }}
                          >
                            <img
                              className="img-fluid docs-image"
                              alt="Doctor"
                              src={
                                doc?.profileImage
                                  ? `${serverConfig.BASE_URL}/uploads/${doc.profileImage}`
                                  : `${serverConfig.BASE_URL}/uploads/demo.jpg`
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "assets/img/doctor.png";
                              }}
                            />
                          </a>
                        </div>

                        <div className="pro-content">
                          <h3 className="title">
                            <a href="/"
                                role="button"
                             onClick={(e) => {
                                e.preventDefault();
                                doc?.showIdentity === 'Y' && doc?.kycAccept === 'Y'
                                  ? handleViewDoctor(doc?.userId)
                                  : Swal.fire({
                                    title: 'Warning!',
                                    text: 'Identity is not verified.',
                                    icon: 'warning',
                                    confirmButtonColor: '#566fe2',
                                    customClass: {
                                      title: 'swal-title-small',
                                      popup: 'swal-popup-small',
                                      confirmButton: 'swal-button-small'
                                    }
                                  });
                              }}
                            >{doc?.firstName + " " + doc?.lastName}</a>
                            <i className="fas fa-check-circle verified" />
                          </h3>

                          <p className="speciality">
                            {doc?.qualification || ""}, {doc?.departmentName || ""}
                          </p>

                          <div className="rating">
                            <i className="fas fa-star filled" />
                            <i className="fas fa-star filled" />
                            <i className="fas fa-star filled" />
                            <i className="fas fa-star filled" />
                            <i className="fas fa-star filled" />
                            <span className="average-rating">(5)</span>
                          </div>

                          <ul className="available-info">
                            <li>
                              <i className="fas fa-map-marker-alt" /> {doc?.officeAddress}
                            </li>
                            <li style={{ color: 'red' }}>
                              <i className="far fa-clock" />    {doc?.availableToday === "Y"
                                ? `Available on ${formattedDate}`
                                : `Not available on ${formattedDate}`}
                            </li>
                          </ul>

                          {/* ✅ Fee + Button Row */}
                          <div className="d-flex justify-content-between align-items-center mt-2">

                            <div>
                              <p style={{ color: 'blue', margin: 0, fontWeight: '500' }}> Consultation Fees</p>
                              <strong>₹ {doc?.consultationFee}</strong>
                            </div>

                            <button
                              onClick={() => {
                                doc?.showIdentity === 'Y' && doc?.kycAccept === 'Y'
                                  ? handleViewDoctor(doc?.userId)
                                  : Swal.fire({
                                    title: 'Warning!',
                                    text: 'Identity is not verified.',
                                    icon: 'warning',
                                    confirmButtonColor: '#566fe2',
                                    customClass: {
                                      title: 'swal-title-small',
                                      popup: 'swal-popup-small',
                                      confirmButton: 'swal-button-small'
                                    }
                                  });
                              }}
                              className="btn btn-primary book-btn1 px-2 py-1 w-50"
                            >
                              Book Now
                            </button>

                          </div>
                        </div>

                      </div>

                    ))
                  ) : (
                    <div>There is no doctors</div>
                  )}

                </Slider>
              </div>
            </div>
          </div>
        </section>

        {/* /Popular Section */}
        {/* Availabe Features */}
        <section className="section section-features">
          <div className="container">
            <div className="row">
              <div className="col-md-5 features-img aos" data-aos="fade-up">
                <img src="assets/img/features/f1.png" className="img-fluid" alt="Feature" />
              </div>
              <div className="col-md-7 aos" data-aos="fade-up">
                <div className="section-header">
                  <h2 className="mt-2">Comprehensive Patient Services</h2>
                  <p>Explore advanced healthcare features in our clinic, including online booking,
                    diagnostics, consultations, and patient management. </p>
                </div>
                <Slider {...settings} className="features-slider-react">

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-01.png" className="img-fluid" alt="Feature" />
                    <p>Appointment</p>
                  </div>

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-02.png" className="img-fluid" alt="Feature" />
                    <p>Consultations</p>
                  </div>

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-03.png" className="img-fluid" alt="Feature" />
                    <p>Prescriptions</p>
                  </div>

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-04.png" className="img-fluid" alt="Feature" />
                    <p>Pharmacy</p>
                  </div>

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-05.png" className="img-fluid" alt="Feature" />
                    <p>Records</p>
                  </div>

                  {/* Slider Item */}
                  <div className="feature-item text-center">
                    <img src="assets/img/features/feature-06.png" className="img-fluid" alt="Feature" />
                    <p>Reports</p>
                  </div>

                </Slider>

              </div>
            </div>
          </div>
        </section>
        {/* /Availabe Features */}
      </div>
    </>
  );
}